import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { AudioFormat } from 'constants/enums'
import { ListButton } from 'components'

/**
 * @desc Track options dropdown menu component
 * @memberof components/playlist/PlaylistTrackOptions
 *
 * @param  {Boolean} isDownloadAllowed              [Show 'Download' option]
 *
 * @param  {Function} t                      		[i18 string getter (Autowired)]
 * @param  {Function} onDownloadClick               [(Optional) 'Download' option click handler]
 * @param  {Function} onAddToPlaylistClick          ['Add to playlist' option click handler]
 * @param  {Function} onRemoveClick                 ['Remove' option click handler]
 *
 * @type {Component}
 */
const TrackOptionsMenu = ({
  t,
  isDownloadAllowed,
  onDownloadClick,
  onAddToPlaylistClick,
  onRemoveClick
}) => (
  <React.Fragment>
    {isDownloadAllowed && (
      <>
        <ListButton
          key={1}
          name={t('general.download-wav')}
          onClick={() => onDownloadClick(AudioFormat.wav?.value)}
        />
        <ListButton
          key={2}
          name={t('general.download-mp3')}
          onClick={() => onDownloadClick(AudioFormat.mp3?.value)}
        />
      </>
    )}
    <ListButton
      key={2}
      name={t('collections.remove')}
      onClick={onRemoveClick}
    />
    <ListButton
      key={3}
      name={t('playlist.add-to-another-playlist')}
      onClick={onAddToPlaylistClick}
    />
  </React.Fragment>
)

TrackOptionsMenu.propTypes = {
  isDownloadAllowed: PropTypes.bool,

  t: PropTypes.func.isRequired,
  onDownloadClick: PropTypes.func,
  onAddToPlaylistClick: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired
}
TrackOptionsMenu.defaultProps = {
  isDownloadAllowed: false
}

export default withTranslation()(TrackOptionsMenu)
